module.exports = __webpack_public_path__ + "img/diagram.84603100.svg";